__turbopack_context__.v({
  "Content": "ImageTeaserHorizontal-module-scss-module__uRp0JG__Content",
  "Date": "ImageTeaserHorizontal-module-scss-module__uRp0JG__Date",
  "Description": "ImageTeaserHorizontal-module-scss-module__uRp0JG__Description",
  "Image": "ImageTeaserHorizontal-module-scss-module__uRp0JG__Image",
  "IsHighlighted": "ImageTeaserHorizontal-module-scss-module__uRp0JG__IsHighlighted",
  "IsHorizontal": "ImageTeaserHorizontal-module-scss-module__uRp0JG__IsHorizontal",
  "Tag": "ImageTeaserHorizontal-module-scss-module__uRp0JG__Tag",
  "Teaser": "ImageTeaserHorizontal-module-scss-module__uRp0JG__Teaser",
  "Title": "ImageTeaserHorizontal-module-scss-module__uRp0JG__Title",
});
